import * as types from './mutation-types'
export default {
  [types.SET_MASTER](state, master) {
    state.master = master
  },
}
